// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* صفحه اصلی */
.app-container {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;

    /* بک‌گراند خفن با نورهای سینماتیک */
    background: radial-gradient(circle at 20% 20%, #ff3d3d55, #000000 70%),
    radial-gradient(circle at 80% 80%, #4d4dff55, #000000 70%),
    #000;

    background-blend-mode: screen;
    overflow: hidden;
    position: relative;
    font-family: "Segoe UI", sans-serif;
}

/* نورهای شناور */
.app-container::before,
.app-container::after {
    content: "";
    position: absolute;
    width: 350px;
    height: 350px;
    border-radius: 50%;
    filter: blur(120px);
    opacity: 0.4;
    animation: float 8s infinite ease-in-out alternate;
}

.app-container::before {
    background: #ff3d3d;
    top: -50px;
    left: -50px;
}

.app-container::after {
    background: #4d4dff;
    bottom: -50px;
    right: -50px;
}

@keyframes float {
    from { transform: translateY(0px); }
    to { transform: translateY(40px); }
}

/* کارت شیشه‌ای */
.card {
    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(18px) saturate(180%);
    padding: 35px 45px;
    border-radius: 18px;
    width: 360px;
    box-shadow: 0 0 40px rgba(0,0,0,0.5);
    border: 1px solid rgba(255,255,255,0.15);
    animation: fadeIn 0.5s ease;
}

/* عنوان */
.title {
    text-align: center;
    color: #fff;
    margin-bottom: 25px;
    font-size: 24px;
    font-weight: 600;
}

/* ورودی‌ها */
.input-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
}

.input-group label {
    color: #ddd;
    margin-bottom: 6px;
    font-size: 14px;
}

.input-group select,.input-group input {
    padding: 10px;
    border-radius: 8px;
    border: none;
    background: #222;
    color: #fff;
    font-size: 15px;
    outline: none;
    transition: 0.2s;
}

.input-group select:hover {
    background: #2d2d2d;
}

/* دکمه Join */
.join-btn {
    width: 100%;
    padding: 12px;
    background: #ff4d4d;
    border: none;
    border-radius: 10px;
    color: white;
    font-size: 17px;
    cursor: pointer;
    transition: 0.2s;
    margin-top: 10px;
}

.join-btn:hover {
    background: #ff3333;
    transform: translateY(-2px);
}

/* انیمیشن */
@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/AppUI.css"],"names":[],"mappings":"AAAA,cAAc;AACd;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,oCAAoC;IACpC;;QAEI;;IAEJ,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA,iBAAiB;AACjB;;IAEI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,OAAO,0BAA0B,EAAE;IACnC,KAAK,2BAA2B,EAAE;AACtC;;AAEA,iBAAiB;AACjB;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,oCAAoC;IACpC,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA,UAAU;AACV;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA,aAAa;AACb;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA,YAAY;AACZ;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C","sourcesContent":["/* صفحه اصلی */\r\n.app-container {\r\n    height: 100vh;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n    /* بک‌گراند خفن با نورهای سینماتیک */\r\n    background: radial-gradient(circle at 20% 20%, #ff3d3d55, #000000 70%),\r\n    radial-gradient(circle at 80% 80%, #4d4dff55, #000000 70%),\r\n    #000;\r\n\r\n    background-blend-mode: screen;\r\n    overflow: hidden;\r\n    position: relative;\r\n    font-family: \"Segoe UI\", sans-serif;\r\n}\r\n\r\n/* نورهای شناور */\r\n.app-container::before,\r\n.app-container::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    width: 350px;\r\n    height: 350px;\r\n    border-radius: 50%;\r\n    filter: blur(120px);\r\n    opacity: 0.4;\r\n    animation: float 8s infinite ease-in-out alternate;\r\n}\r\n\r\n.app-container::before {\r\n    background: #ff3d3d;\r\n    top: -50px;\r\n    left: -50px;\r\n}\r\n\r\n.app-container::after {\r\n    background: #4d4dff;\r\n    bottom: -50px;\r\n    right: -50px;\r\n}\r\n\r\n@keyframes float {\r\n    from { transform: translateY(0px); }\r\n    to { transform: translateY(40px); }\r\n}\r\n\r\n/* کارت شیشه‌ای */\r\n.card {\r\n    background: rgba(255, 255, 255, 0.08);\r\n    backdrop-filter: blur(18px) saturate(180%);\r\n    padding: 35px 45px;\r\n    border-radius: 18px;\r\n    width: 360px;\r\n    box-shadow: 0 0 40px rgba(0,0,0,0.5);\r\n    border: 1px solid rgba(255,255,255,0.15);\r\n    animation: fadeIn 0.5s ease;\r\n}\r\n\r\n/* عنوان */\r\n.title {\r\n    text-align: center;\r\n    color: #fff;\r\n    margin-bottom: 25px;\r\n    font-size: 24px;\r\n    font-weight: 600;\r\n}\r\n\r\n/* ورودی‌ها */\r\n.input-group {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.input-group label {\r\n    color: #ddd;\r\n    margin-bottom: 6px;\r\n    font-size: 14px;\r\n}\r\n\r\n.input-group select,.input-group input {\r\n    padding: 10px;\r\n    border-radius: 8px;\r\n    border: none;\r\n    background: #222;\r\n    color: #fff;\r\n    font-size: 15px;\r\n    outline: none;\r\n    transition: 0.2s;\r\n}\r\n\r\n.input-group select:hover {\r\n    background: #2d2d2d;\r\n}\r\n\r\n/* دکمه Join */\r\n.join-btn {\r\n    width: 100%;\r\n    padding: 12px;\r\n    background: #ff4d4d;\r\n    border: none;\r\n    border-radius: 10px;\r\n    color: white;\r\n    font-size: 17px;\r\n    cursor: pointer;\r\n    transition: 0.2s;\r\n    margin-top: 10px;\r\n}\r\n\r\n.join-btn:hover {\r\n    background: #ff3333;\r\n    transform: translateY(-2px);\r\n}\r\n\r\n/* انیمیشن */\r\n@keyframes fadeIn {\r\n    from { opacity: 0; transform: translateY(10px); }\r\n    to { opacity: 1; transform: translateY(0); }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
